export default __webpack_public_path__ + "static/media/george_m.36cba27d.jpg";